import { Text } from '@fozito/common-ui';
import { get } from 'lodash';
import styled from 'styled-components';
import add_price_icon from './icons/add-price.svg';
import on_hold_icon from './icons/on-hold.svg';
import sell_gift_icon from './icons/sell-gift.svg';
import VIP_icon from './icons/VIP.svg';
import cash_deposit_icon from './icons/cash-deposit.svg';

export enum HeaderActionButtonType {
  CASH_DEPOSIT = 'CASH_DEPOSIT',
  ADD_PRICE = 'ADD_PRICE',
  SELL_GIFT = 'SELL_GIFT',
  ON_HOLD = 'ON_HOLD',
  VIP = 'VIP',
}
const configs = {
  [HeaderActionButtonType.CASH_DEPOSIT]: {
    icon: cash_deposit_icon,
    label: 'Cash Deposit',
  },
  [HeaderActionButtonType.ADD_PRICE]: {
    icon: add_price_icon,
    label: 'Add Price',
  },
  [HeaderActionButtonType.SELL_GIFT]: {
    icon: sell_gift_icon,
    label: 'Gift Cards',
  },
  [HeaderActionButtonType.ON_HOLD]: {
    icon: on_hold_icon,
    label: 'On Hold',
  },
  [HeaderActionButtonType.VIP]: {
    icon: VIP_icon,
    label: 'VIP',
  },
};
type Props = {
  type: HeaderActionButtonType,
  onClick: () => void;
  count?: number;
};
const HeaderActionButton = ({ onClick, type, count }: Props) => {
  const config = get(configs, type);
  if (!config) return null;

  return (
    <Container accessKey='' type='button' onClick={e => [e.preventDefault(), e.stopPropagation(), onClick()]} style={{ zIndex: count ? 2 : 0 }}>
      <img src={config.icon} alt={config.label} style={{ height: 50, width: 'auto' }} />
      <Text className='label'>{config.label}</Text>
      {!!count && <CountBox className=''><Text content_content_2_16_medium >{count}</Text></CountBox>}
    </Container>
  );
};

export default HeaderActionButton;

const CountBox = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(12px,-8px);
  display: flex;
  width: 32px;
  height: 32px;
  padding: 10px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  aspect-ratio: 1/1;
  border-radius: 100px;
  background: #D2464F;
  .content_content_2_16_medium {
    color: #FFF;
    text-align: center;
  }
`;

const Container = styled.button`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 140px;
  position: relative;
  align-self: stretch;
  border-radius: 5px;
  border: 1px solid #232F3E;
  background: #FFF;

  .label {
    color: #1D2129;
    text-align: center;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  &:hover,
  &:active {
    opacity: 0.8;
    transform: scale(1.05);
    transition: all 0.1s;
  }

  &:disabled {
    opacity: 0.7;
    &:hover,
    &:active {
      opacity: 0.7;
      cursor: not-allowed;
      transform: none;
      transition: none;
    }
  }
`;